import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Injector, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { NotificationService } from 'src/app/services/notification.service';
import { PDFService } from 'src/app/services/PDF/pdfservice.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { base64ToBlob, formatCurrency, generatePDF } from 'src/app/util/Helper';
import { GrantLetterComponent } from 'src/app/util/PDF/grant-letter/grant-letter.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step6-preview',
  templateUrl: './step6-preview.component.html',
  styleUrls: ['./step6-preview.component.scss']
})
export class Step6PreviewComponent {
  @ViewChild('pdfContent', { static: false }) pdfContent?: ElementRef;
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  @ViewChild('grantContent') grantContent!: TemplateRef<any>;
  @ViewChild('grantSignatureButton') grantSignatureButton!: TemplateRef<any>;

  private grantLetterComponent: GrantLetterComponent | null = null;
  
  title: string = 'Preview your Information.';

  personalDataTitle: string = 'Personal Data';
  settlorsTitle: string = 'Settlors';
  bensTitle: string = 'Beneficiaries';
  guardiansTitle: string = 'Guardians';
  trustInfoTtile: string = 'Additional Trust Information';

  editText: string = 'Edit Information';

  termAccepted: boolean = false;

  buttonEnabled: boolean = true;

  isPopupVisible = false;
  record: any;
  recordType: 'Info' | 'Settlor' | 'Guardian' | 'Beneficiary' = 'Settlor';
  recordIndex: number = 0;

  loading: boolean = false;
  formatCurrency = formatCurrency;


  // FORM !
  previewForm = this._formBuilder.group({
    iSwear: [false],
  });

  constructor(
    private tabControlService: TabControlService,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private currencyPipe: CurrencyPipe,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private pdfService: PDFService,
    private cdr: ChangeDetectorRef
  ) {}

  isModalOpen = false;
  isGrantVisible = false;

  get basicData(): any {
    return this.tabControlService.basicData;
  }
  get settlors(): any {
    return this.tabControlService.settlors;
  }
  get beneficiaries(): any {
    return this.tabControlService.beneficiaries;
  }
  get guardians(): any {
    return this.tabControlService.guardians;
  }
  get trustInfo(): any {
    return this.tabControlService.trustInfo;
  }
  get activeTab(): number {
    return this.tabControlService.activeTab;
  }

  get settlorType(): 0 | 1 {
    return this.tabControlService.settlorType;
  }

  get signatureImage() {
    return this.tabControlService.signatureImage;
  }

  get saveProgress(): ()=> void {
    return this.tabControlService.saveProgress;
  }

  organizedPurpose: string = '';
  organizedSource: string = '';

  ngOnInit(): void {
    console.log(this.trustInfo)
    // this.organizedPurpose = this.organizeValues(this.trustInfo.TrustPurpose);
    // this.organizedSource = this.organizeValues(this.trustInfo.SourceOfFunds);
  }

  organizeValues(items: any): string {
    try {
      let output: string = items[0];
      for (let i=1; i<items.length; i++) {
        output = output + ', ' +items[i];
      }
      console.log('Final output : ', output);
      return output;
    } catch (error) {
      console.log('Error', error);
      return '';
    }
  }

  arrayContainsValue(arr: string | null | undefined, value: string) {
    return arr && arr.includes(value);
  }

  arraysContainValue(arr: any[] | null | undefined, value: string) {
    let exists = false

    if (arr)
      arr.forEach(element => {
        if (element.TrustPurpose && element.TrustPurpose.length > 0) {
          if (this.arrayContainsValue(element.TrustPurpose, value)) exists = true;
        }
      });

      return exists;
  }

  onPopupClose(): void {
    this.isPopupVisible = false;
  }

  showPopup(): void {
    this.isPopupVisible = true;
  }

  editRecord(recordType: 'Info' | 'Settlor' | 'Guardian' | 'Beneficiary', recordIndex: number): void {
    this.record = this.tabControlService.settlors[recordIndex];
    if (recordType === 'Guardian') this.record = this.tabControlService.guardians[recordIndex];
    else if (recordType === 'Beneficiary') this.record = this.tabControlService.beneficiaries[recordIndex];
    else if (recordType === 'Info') this.record = this.tabControlService.trustInfo;

    this.recordType = recordType;
    this.recordIndex = recordIndex;

    this.showPopup();
  }

  async captureSummary(): Promise<void> {
    this.loading = true;
    try {
      const element = this.pdfContent?.nativeElement;
      // const trustName = this.trustInfo.TrustName;
      const summary = await generatePDF(element, this.trustInfo.TrustName, false, false, [250, 350], 1);

      if (summary === 'error') {
        console.error('Summary not captured');
      } else {
        // For testing
        // const pdfBlob = base64ToBlob(summary);
        // this.openPDFInNewTab(pdfBlob);

        this.tabControlService.updateRecord(6, summary);
        this.tabControlService.updateTrustProgress('Preview');
      }
    } catch (error) {
      console.error('Error !! ', error);
    }
    this.loading = false;
  }

  // Preview Grant Letter
  openGrantLetterModal = (): void => {
    const dialogRef = this.dialog.open(ModalComponent, {
      maxWidth: '1100px', 
      height: '98%',
      maxHeight: '1100px',
      data: {
        contentTemplate: this.grantContent,
        modalTitle: 'Read and Sign Grant Letter',
        buttonText: 'Back',
        buttonTemplate: this.grantSignatureButton,
      },
      disableClose: true // Disable closing when clicking outside the modal
    });

    this.notificationService.addModal(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      this.notificationService.removeModal(dialogRef);
      this.isGrantVisible = false;
    });
  }

  // Contract Formation Handling
  openSignatureModal = (): void => {
    const dialogRef = this.dialog.open(ModalComponent, {
      maxWidth: '1400px',  // Maximum width of the modal
      height: 'fit-content',
      maxHeight: '1100px',
      data: {
        contentTemplate: this.modalContent,
        modalTitle: 'Draw Your Signature',
        buttonText: 'Cancel'
      },
      disableClose: true // Disable closing when clicking outside the modal
    });

    this.notificationService.addModal(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      this.notificationService.removeModal(dialogRef);
      this.isModalOpen = false;
    });
  }

  onSignatureSaved = async(signatureImage: string): Promise<void> => {
    // if (!environment.production) console.log('Signature captured:', signatureImage);
    this.tabControlService.signatureImage = signatureImage;

    this.notificationService.closeAllModals();
    this.tabControlService.page6Done = true;
    await this.tabControlService.changeTab(7);

    this.notificationService.viewToast('success', 'The complete & signed document will be sent to your email once you complete payment')

  }

  async updateProgress(): Promise<void> {
    this.saveProgress();
  }

  async submitForm(): Promise<void> {
    this.captureSummary();
    if (this.signatureImage) {
      this.tabControlService.page6Done = true;
      await this.tabControlService.changeTab(7);
    } else {
      this.openGrantLetterModal();
    } 

    // For running tests
    // this.generateTestPDF();
  }

  // +++++++++++ For testing PDF generation
  generateTestPDF = async () => {
    this.notificationService.isLoading(true);
    try {
      this.destroyGrantLetterComponent();
      this.viewContainerRef.clear();

      // Force change detection and Add a small delay to ensure cleanup is complete
      this.cdr.detectChanges();
      await new Promise(resolve => setTimeout(resolve, 50));

      // Create component
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(GrantLetterComponent);
      const componentRef = this.viewContainerRef.createComponent(componentFactory, 0, this.injector);
      this.grantLetterComponent = componentRef.instance;

      // Set payment amount
      const amount = 420;
      this.grantLetterComponent.paymentAmount = this.currencyPipe.transform(amount, 'KSH ', 'symbol', '1.0-0') || '';
  
      // Wait for paymentAmount to be ready
      await this.grantLetterComponent.waitForPaymentAmount();

      // Trigger change detection
      this.cdr.detectChanges();
  
      // Wait for component to initialize
      await new Promise(resolve => setTimeout(resolve, 50));

      // Get PDF content
      const pdfGrantContent = await this.pdfService.waitForPdfGrantContent();
      if (!pdfGrantContent) throw new Error('PDF content not available');

      // Double-check rendering
      this.cdr.detectChanges();
      await new Promise(resolve => requestAnimationFrame(resolve));

      const grantLetter = await generatePDF(pdfGrantContent.nativeElement, 'Grant Letter');
      // Convert grantLetter (base64) to a Blob
      const pdfBlob = base64ToBlob(grantLetter);

      this.openPDFInNewTab(pdfBlob);
    } catch (error) {
      console.error(error)
    }
    this.notificationService.isLoading(false);
  }

  openPDFInNewTab = (data: Blob): void => {
    const url = window.URL.createObjectURL(data); // Create a Blob URL
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer'); // Open the PDF in a new tab

    if (newWindow) {
      // Immediately return focus to the original tab
      window.focus();
    }
    window.URL.revokeObjectURL(url); // Release the Blob URL
  };

  destroyGrantLetterComponent = () => {
    if (this.grantLetterComponent) {
      // Clear the PDF service state
      this.pdfService.setGrantPdfContent(null);
      
      // Destroy component
      this.viewContainerRef.clear();
      this.grantLetterComponent = null;
      
      // Force change detection
      this.cdr.detectChanges();
      if (!environment.production) console.log('Grant PDF cleared');
    }
  };
}
